// TODO [refactor] see MemberPurchaseItemPage.js, PurchaseInstalmentPage.js

import { useState, useCallback } from 'react'
import { connect } from 'react-redux'
import {
  checkoutTapPayAction,
  loadTapPaySDKAction,
} from '../../actions/tapPayActions'
import { getTimezone } from '../../libs/dates'
import {
  formatNumber,
  remove886,
  to886,
  toSegmentedPhoneNumber,
} from '../../libs/utils'
import TableRow from '../babu/TableRow'
import BottomButtonArea from '../common/BottomButtonArea'
import ItemQuantitySelect from '../common/ItemQuantitySelect'
import NavBar from '../common/NavBar'
import useGA4Pageview from '../libs/hooks/useGA4Pageview'
import useItemQuantity from '../libs/hooks/useItemQuantity'
import TapPayPaymentPage from '../tappay/TapPayPaymentPage'
import AgreeTermsCard from './AgreeTermsCard'
import ConfirmPurchaseTopArea from './ConfirmPurchaseTopArea'
import FetchPaymentInfo from './FetchPaymentInfo'
import SelectPaymentCard from './SelectPaymentCard'

/*
  paymentInfo: {
    "title": "團購名稱",
    "contact": "+886912345678",
    "payment_amount": 335,  // 不分期/首期應付金額 (台幣)
    "exchange_rate": 31,    // 台幣兌美元匯率
    "status": "created"     // created (開放中); terminated (已停止收款); filled (已額滿); expired (已結束)
  }
 */

/*
  props: paymentInfo, guestId, itemId, loadSDK, checkoutTapPay
 */
function GuestPurchaseItem(props) {
  const [openTapPay, setOpenTapPay] = useState(false)
  const [agreed, setAgreed] = useState(false)

  const checkoutButtonCallback = useCallback(() => {
    if (agreed) {
      setOpenTapPay(true)
    }
  }, [agreed, setOpenTapPay])

  const {
    paymentInfo,
    guestId,
    vendorInfo,
    contactName,
    contactEmail,
    sentPhone,
  } = props

  const guestInfo = {
    contact_name: contactName,
    contact_email: contactEmail,
  }

  const {
    instalment,
    price: pricePerQty,
    max_qty: maxQuantity,
    payment_amount: paymentAmount,
    exchange_rate: exchangeRate,
  } = paymentInfo

  const isInstalment = instalment > 1

  const { quantity, setQuantity, quantityFixed } = useItemQuantity(maxQuantity)

  const quantitySelectable = isInstalment ? false : maxQuantity > 1
  const amount = quantitySelectable ? pricePerQty * quantity : paymentAmount

  useGA4Pageview('slash_checkout_creditcard')

  if (openTapPay) {
    return (
      <TapPayPaymentPage
        price={amount}
        onCancel={() => setOpenTapPay(false)}
        toPurchaseLoginPage={props.toPurchaseLoginPage}
        onCheckout={() => {
          props.checkoutTapPay(
            guestId,
            props.itemId,
            guestInfo,
            quantity,
            maxQuantity,
          )
        }}
        loadSDK={() => {
          props.loadSDK(guestId, sentPhone, props.itemId)
        }}
      />
    )
  }

  return (
    <>
      <NavBar />
      <BottomButtonArea
        variant="solid"
        disabled={!agreed}
        onClick={checkoutButtonCallback}>
        {`支付 NT$${formatNumber(amount)}`}
      </BottomButtonArea>
      <ConfirmPurchaseTopArea
        phone={sentPhone}
        amount={amount}
        amountUSD={amount / exchangeRate}
      />
      <div className="container px-xs">
        {vendorInfo ? (
          <TableRow
            content="收款商家"
            accessoryLabel={vendorInfo.name}
            divided
          />
        ) : (
          <TableRow
            content="賣家手機"
            accessoryLabel={toSegmentedPhoneNumber(
              remove886(paymentInfo.contact),
            )}
            divided
          />
        )}
        <TableRow content="名稱" accessoryLabel={paymentInfo.title} divided />
        <TableRow
          content="單價"
          accessoryLabel={`NT$${formatNumber(pricePerQty)}`}
          divided
        />
        {quantitySelectable ? (
          <TableRow
            content="數量"
            accessory={
              <ItemQuantitySelect
                maxQuantity={maxQuantity}
                quantity={quantity}
                setQuantity={setQuantity}
                quantityFixed={quantityFixed}
              />
            }
            divided
          />
        ) : null}
      </div>
      <div className="container mt-l mb-30">
        <SelectPaymentCard />
        <AgreeTermsCard
          agreed={agreed}
          setAgreed={setAgreed}
          cardClassName="mt-m"
        />
      </div>
    </>
  )
}

const ConnectedGuestPurchaseItem = connect(
  state => ({
    paymentInfo: state.buyer.paymentInfo,
    sentPhone: state.sms.sentPhone,
    guestId: state.sms.guestId,
    vendorInfo: state.vendor.vendorInfo,
    contactName: state.sms.contactName,
    contactEmail: state.sms.contactEmail,
  }),
  dispatch => ({
    checkoutTapPay(guestId, itemId, guestInfo, qty, maxQuantity) {
      dispatch(
        checkoutTapPayAction({
          qty,
          maxQuantity,
          isGuest: true,
          member_id: guestId,
          cream_item_id: itemId,
          timezone: getTimezone(),
          cash_discount: 0,
          reward_discount: 0,
          token_discount: 0,
          ...guestInfo,
        }),
      )
    },
    loadSDK(guestId, mobile, itemId) {
      dispatch(
        loadTapPaySDKAction(
          {},
          {
            itemId,
            member_id: guestId,
            mobile: to886(mobile),
          },
        ),
      )
    },
  }),
)(GuestPurchaseItem)

export default function GuestPurchaseItemPage(props) {
  return (
    <FetchPaymentInfo itemId={props.itemId}>
      <ConnectedGuestPurchaseItem
        toPurchaseLoginPage={props.toPurchaseLoginPage}
      />
    </FetchPaymentInfo>
  )
}
